import { createContext, PropsWithChildren, useContext, useState } from "react";

export type CategoryChildNode = {
  isOpen: boolean;
  children: Record<string, CategoryChildNode>;
};
interface HelpCenterContextType {
  openNodes: Record<string, CategoryChildNode>;
  toggleNode: (id: string, parentIds?: string[]) => void;
  closeAllNodes: () => void;
}
/*
 help center slide Node 를 위한 Context
 */
const HelpCenterContext = createContext<HelpCenterContextType | undefined>(
  undefined,
);

export const useHelpCenterContext = () => {
  const context = useContext(HelpCenterContext);

  if (!context) {
    throw new Error("Context must be used within  Provider.");
  }

  return context;
};

export const HelpContextProvider = ({
  children,
  initialOpenNodes,
}: PropsWithChildren<{
  initialOpenNodes?: Record<string, CategoryChildNode>;
}>) => {
  const [openNodes, setOpenNodes] = useState<
    HelpCenterContextType["openNodes"]
  >(initialOpenNodes ?? {});

  /*
    id : NodeId
    parentIds: 부모 노드 Id 목록 (특정 노드 추적을 위한)
   */
  const toggleNode = (id: string, parentIds: string[] = []) => {
    setOpenNodes((prev) => {
      // 부모 노드 경로 복사 - 열림 상태 변경시 사용
      let updatedNodes = { ...prev };
      let currentNode = updatedNodes;

      // 자식 노드 상태 찾기 - 부모 노드의 children으로 이동
      parentIds.forEach((parentId) => {
        if (!currentNode[parentId]) {
          currentNode[parentId] = { isOpen: false, children: {} };
        }
        //현재 노드에 선택 노드할당
        currentNode = currentNode[parentId].children;
      });

      // 현재 노드가 존재하지 않으면 초기화
      if (!currentNode[id]) {
        currentNode[id] = { isOpen: false, children: {} };
      }

      //선택노드의 열림 상태 변경
      currentNode[id].isOpen = !currentNode[id].isOpen;
      return updatedNodes;
    });
  };

  const closeAllNodes = () => {
    setOpenNodes({});
  };

  return (
    <HelpCenterContext.Provider
      value={{ openNodes, toggleNode, closeAllNodes }}
    >
      {children}
    </HelpCenterContext.Provider>
  );
};
